import { Suspense, useState } from "react";
import { Toast } from "primereact/toast";
import AppLoading from "../app-loading/app-loading";
import OilProductionSearch from "./OilProductionSearchRecords";
import OilProductionDataTable from "./OilProductionDataTable1";
import OilProductionDataTable1 from "./OilProductionDataTable2";
import { useTranslation } from "react-i18next";
import { OilIntakeLogModel } from "../../models/oilProduction-model";
import { BreadCrumb } from "primereact/breadcrumb";

const OilProductionLog1: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState<OilIntakeLogModel[]>([]);

 const breadcrumbItems = [
    { label: "Oil Mill Operations", url: "" },
    { label: "Stage 2 : Start Production", url: "" }
  ];
  const home = { icon: "pi pi-home", url: "/" };

  const handleSearch = (data: any[]) => {
    setFilteredData(data);
  };

  return (
    <Suspense fallback={<AppLoading />}>
<div className="layout-content mt-3 mb-3 px-2 md:px-4 lg:px-6 grid grid-table-mobile max-w-screen-xl mx-auto">

  <div className="col-12">
    <h5
      className="border-round order-top-color p-2 m-0 mb-1"
      style={{ width: "fit-content" }}
    >
      Stage 2 : Start Production
    </h5>
    <BreadCrumb
      model={breadcrumbItems}
      home={home}
      className="bg-transparent px-0 py-0 text-sm  text-gray-600"
      style={{
        border: "none",
        boxShadow: "none",
        background: "transparent",
        marginLeft: "5px",
      }}
    />
  </div>

  <div className="col-12 mb-4">
    <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container">
      <OilProductionSearch onSearch={handleSearch} setLoading={setLoading} />
    </div>
  </div>

  <div className="col-12">
    <OilProductionDataTable data={filteredData} setLoading={setLoading} />
  </div>

</div>

      {loading && <AppLoading />}
    </Suspense>
  );
};

export default OilProductionLog1;
